var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['comp-button-small', { 'comp-button-small--attr': _vm.value }],attrs:{"data-attr":_vm.value ? _vm.value : false,"type":"button"},on:{"click":function($event){$event.target.blur();
    _vm.$emit('click', $event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }